import { jsx as _jsx } from "react/jsx-runtime";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import * as React from "react";
import { useState } from "react";
import { HXIconButton } from "./HXButton";
import { HXTextField } from "./base.styles";
import { colors } from "healthex-common/colors";
export const HXPasswordTextField = (props) => {
    const [showPassword, setShowPassword] = useState(false);
    return (_jsx(HXTextField, { error: props.error, helperText: props.helperText, type: showPassword ? "text" : "password", InputProps: {
            endAdornment: props.value ? (_jsx(InputAdornment, { position: "end", children: _jsx(HXIconButton, { onClick: () => setShowPassword((oldValue) => !oldValue), style: { color: colors.black_lighter }, children: showPassword ? _jsx(VisibilityOff, {}) : _jsx(Visibility, {}) }) })) : undefined,
        }, ...props }));
};
